import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { Profession } from '../../users/schemas/profession'

export const consumers = createQueryKeys('consumers', {
  all: null,
  me: null,
  businesses: null,
  businessById: (businessId: number) => ({
    queryKey: [{ businessId }],
  }),
  teamMemberships: (teamId: number) => ({
    queryKey: [{ teamId }],
  }),
  businessInvitations: (businessId: number, profession: Profession) => ({
    queryKey: [{ businessId, profession }],
  }),
  detail: (consumerId: string) => ({
    queryKey: [{ consumerId }],
  }),
  leads: (profession?: string) => ({
    queryKey: [{ profession }],
  }),
  exists: (email: string) => ({
    queryKey: [{ email }],
  }),
})
